// auth.service.ts
import { Injectable } from '@angular/core';
import moment from 'moment-timezone';
import { Session } from '../../../utils/session.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private isAuthenticatedSubject = new BehaviorSubject<boolean>(this.hasToken());
  isAuthenticated$ = this.isAuthenticatedSubject.asObservable();

  constructor() {
    // Verificar si hay un token almacenado al iniciar
    const token = localStorage.getItem('secTkn');
    if (token) {
      this.isAuthenticatedSubject.next(true);
    }
  }

  private hasToken(): boolean {
    return Boolean(localStorage.getItem('secTkn'));
  }

  private checkToken(): boolean {
    return Boolean(localStorage.getItem('secTkn'));
  }

  getSession() {
    const session = localStorage.getItem('session');
    if (session) {
      try {
        return JSON.parse(session);
      } catch (error) {
        throw error;
      }
    }
    return null;
  }

  isLoggedIn(): boolean {
    return this.hasToken();
  }

  isAuthenticated(): boolean {
    return this.isAuthenticatedSubject.value;
  }

  login(token: string): void {
    localStorage.setItem('secTkn', token);
    this.isAuthenticatedSubject.next(true);
  }

  logout(): void {
    localStorage.removeItem('secTkn');
    this.isAuthenticatedSubject.next(false);
  }

  setSession(dataSession: any, isTemporal: boolean = false) {
    const localSession: Session = {
      idClient: dataSession.DBmessage.idClient,
      idTemporaly: dataSession.DBmessage.idTemporaly,
      name: '',
      lastname: '',
      email: '',
      lastLogin: moment().format('YYYY-MM-DD HH:mm:ss'),
      isTemporary: isTemporal,
      token: dataSession.token,
    };
    localStorage.setItem('session', JSON.stringify(localSession));
  }

  getToken() {
    const session: any = localStorage.getItem('session');
    if (session) {
      try {
        const __session = JSON.parse(session);
        return __session.token;
      } catch (error) {
        throw error;
      }
    }
    return null;
  }

  setAuthenticated(status: boolean) {
    console.log('Cambiando estado de autenticación a:', status);
    this.isAuthenticatedSubject.next(status);
  }
}
